import AccountingDocumentState from "../shared/documentInfrastructure/AccountingDocumentState.js";

/**
 * Hold the state for the Forecast on-boarding. This consists mainly in the wizard context.
 */
export default class ForecastOnBoardingDocumentState extends AccountingDocumentState {
	async makeWizardContext() {
		const {
			configuration,
			allKeyFigures,
			accounts,
			chartOfAccountsId,
			vatPaymentSettings,
		} = await this._service.fetchContextData();

		this._chartOfAccountsId = chartOfAccountsId;
		this._configuration = configuration;

		return {
			allKeyFigures,
			configuration,
			accounts,
			vatPaymentSettings,
		};
	}

	updateDefaultConfiguration() {
		return this._service.updateDefaultForecastTemplatesConfiguration(
			this._configuration,
		);
	}

	createForecastTemplate({ model }) {
		return this._service.create({
			notify: false,
			model: { ...model, chartOfAccountsId: this._chartOfAccountsId },
		});
	}
}
